import React from 'react';
import { RoutableLink } from '../../react/RoutableLink';
import { Text, Image, Link, withSitecoreContext, RichText } from '@sitecore-jss/sitecore-jss-react';
import VideoCallout from '@component/VideoCallout';

const ImageVideoCallout = (props) => {
  const target = props.fields?.link?.value?.target === '' ? '_self' : props.fields?.link?.value?.target;
  if (props.fields?.videoembedcode?.value === '') {
    return (
      <VideoCallout
        title={<Text field={props.fields?.title} />}
        body={<RichText field={props.fields?.copy} />}
        cta={<Text field={props.fields?.linktext} />}
        imagesrc={props.fields?.image?.value?.src}
        imagealt={props.fields?.image?.value?.alt}
        handleClick={() => {
          window.open(props.fields?.link?.value?.href, target);
        }}
      />
    );
  }
  return (
    <VideoCallout
      title={<Text field={props.fields?.title} />}
      body={<RichText field={props.fields?.copy} />}
      video={props.fields?.videoembedcode?.value}
      cta={<Text field={props.fields?.linktext} />}
      handleClick={() => {
        window.open(props.fields?.link?.value?.href, target);
      }}
    />
  );
};

export default ImageVideoCallout;
